import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import CachedMessages from "@/components/cached-messages/CachedMessages";
import NewChatButton from "@/components/layout/NewChatButton";

const AdminCachedMessagesPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Management tool for caching messages in MAMBA."
      actions={<NewChatButton />}
    >
      Cached Messages
    </Header>
    <CachedMessages />
  </SpaceBetween>
);

export default AdminCachedMessagesPage;
